import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import linkedin from "../assets/linkedin.png";
import resume from "../assets/resume.png";
import github from "../assets/github.png";

import about01 from "../assets/about01.png";
import about02 from "../assets/about02.png";
import about04 from "../assets/about04.png";
import openSource from "../assets/open-source.jpg";

import profile from "../assets/profile.png";
import circle from "../assets/circle.svg";
import logo from "../assets/logo.png";

import luaGl from "../assets/projects/lua-gl.png";
import luarocks from "../assets/projects/luarocks.png";
import manualReturnsSample from "../assets/manual-returns-sample.svg";

const images = {
  email,
  mobile,
  linkedin,
  resume,
  github,
  about01,
  about02,
  about04,
  openSource,
  profile,
  circle,
  logo,
  luaGl,
  luarocks,
  manualReturnsSample,
};

export default images;
